"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chunkDelim = /(<.+?>)/i;
const ignoreTags = /<\/?\s*(head|link|a|script|style|code|pre|select|textarea|button)([^>]*)\s*>/i;
const closeTags = /^<\/\s*([^>\s]*)\s*>$/i;
//           [ ws ]  [  scheme  ] :// [    host   ] . [   tld  ] / [path]  [   no trailing punct   ] [ ws|punct]
const URL = /( |^)((?:(?:ht|f)tps?:\/\/)?([a-z0-9\-]+\.)+[a-z]{2,63}(?:\/(?:[^\s]*[^\s\x96!\-;'".,?])?)?)([\n .,?]|$)/i;
const markdownLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;
const mdLinkify = (input, linkifier) => {
    return input.replace(markdownLinkRegex, (match, text, url) => {
        return linkifier(url, text);
    });
};
const linkify = (initial, linkifier) => {
    const input = mdLinkify(initial, linkifier);
    let out = '';
    let openTag = '';
    const chunks = input.split(chunkDelim);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const linkReplaceCallBack = (substring, ...args) => {
        return args[0] + linkifier(args[1]) + args[3];
    };
    chunks.forEach((chunk, index) => {
        if (index % 2 === 0) {
            const urls = chunk.match(URL);
            out += openTag !== '' || urls == null ? chunk : chunk.replace(URL, linkReplaceCallBack);
        }
        else {
            let tag = chunk.match(ignoreTags);
            if (tag !== null) {
                if (openTag === '') {
                    openTag = tag[2].trim() === '/' ? '' : tag[1];
                }
                else {
                    tag = chunk.match(closeTags);
                    if (tag != null) {
                        openTag = openTag === tag[1].trim() ? '' : openTag;
                    }
                }
            }
            out += chunk;
        }
    });
    return out;
};
exports.default = linkify;
